// extracted by mini-css-extract-plugin
export var linkText = "_pd-0";